const deleteReaction = reactionRef => {
  return reactionRef
    .delete()
}

export default deleteReaction
